
/*
  Collection pages (all screen sizes): % sticker shape (star / hex / clover
  / wavy) and colour for each card, picked at random from where the card
  sits in the grid:
  - never the same shape or colour as the card to its left or the card
    directly above it;
  - never the same shape + colour combination as any other card in the
    same row (Rachel, Oct 27) - nor, through the rule above, the card
    above it.
  Promo tiles and cards added by Show more are included; cards the
  grid-fill script holds back get theirs once they show.
  Sets data-offe-sticker and --sale-fill on the card, read by
  custom-collection-figma.css (which keeps stickers hidden until then).
*/
(function () {
  var SHAPES = ['star', 'hex', 'clover', 'wavy'];
  var COLORS = ['#a9defe', '#c1b3ff', '#629b26', '#7598e9', '#bebe41'];
  function choose(bannedShapes, bannedColors, bannedCombos) {
    function list(useShapes, useColors) {
      var out = [];
      SHAPES.forEach(function (s) {
        if (useShapes && bannedShapes.indexOf(s) >= 0) return;
        COLORS.forEach(function (c) {
          if (useColors && bannedColors.indexOf(c) >= 0) return;
          if (bannedCombos.indexOf(s + '|' + c) >= 0) return;
          out.push([s, c]);
        });
      });
      return out;
    }
    // strictest first; the row-combo rule is always kept
    var ok = list(true, true);
    if (!ok.length) ok = list(false, true);
    if (!ok.length) ok = list(true, false);
    if (!ok.length) ok = list(false, false);
    if (!ok.length) ok = [[SHAPES[0], COLORS[0]]];
    return ok[Math.floor(Math.random() * ok.length)];
  }
  function run() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll(':scope > .collection-product-card'))
      .filter(function (c) { return c.querySelector('.product-card'); });
    var boxes = cards.map(function (c) {
      var r = c.getBoundingClientRect();
      return { el: c, l: r.left, t: r.top, r: r.right };
    }).filter(function (o) { return o.r > o.l; }); // hidden cards wait until shown
    if (!boxes.some(function (o) { return !o.el.hasAttribute('data-offe-sticker'); })) return;
    boxes.forEach(function (me) {
      if (me.el.hasAttribute('data-offe-sticker')) return;
      var done = boxes.filter(function (o) { return o !== me && o.el.hasAttribute('data-offe-sticker'); });
      var row = done.filter(function (o) { return Math.abs(o.t - me.t) < 4; });
      var left = row.filter(function (o) { return o.r <= me.l + 2 && me.l - o.r < (me.r - me.l); });
      var above = done.filter(function (o) { return Math.abs(o.l - me.l) < 4 && o.t < me.t - 4; });
      if (above.length > 1) above = [above.reduce(function (a, b) { return a.t > b.t ? a : b; })];
      var near = left.concat(above);
      var shapeOf = function (o) { return o.el.getAttribute('data-offe-sticker'); };
      var fillOf = function (o) { return o.el.getAttribute('data-offe-fill'); };
      var pickd = choose(
        near.map(shapeOf),
        near.map(fillOf),
        row.concat(above).map(function (o) { return shapeOf(o) + '|' + fillOf(o); })
      );
      me.el.setAttribute('data-offe-sticker', pickd[0]);
      me.el.setAttribute('data-offe-fill', pickd[1]);
      me.el.style.setProperty('--sale-fill', pickd[1]);
    });
  }
  function start() {
    run();
    var t;
    var target = document.getElementById('MainContent') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 120); })
        .observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  Collection pages, phones and tablets (below 1160px): colour dots whose
  colour name isn't known arrive grey with data-sample (a tiny copy of that
  colour's photo); this fills them with the photo's main colour. Desktop is
  done by custom-figma-desktop.js.
*/
(function () {
  function sample(dot) {
    var src = dot.getAttribute('data-sample');
    if (!src) return;
    dot.removeAttribute('data-sample');
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var size = 32;
        var canvas = document.createElement('canvas');
        canvas.width = size; canvas.height = size;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0, size, size);
        var data = ctx.getImageData(0, 0, size, size).data;
        var px = function (x, y) { var i = (y * size + x) * 4; return [data[i], data[i + 1], data[i + 2]]; };
        var corners = [px(0, 0), px(size - 1, 0), px(0, size - 1), px(size - 1, size - 1)];
        var bg = [0, 1, 2].map(function (k) { return (corners[0][k] + corners[1][k] + corners[2][k] + corners[3][k]) / 4; });
        var r = 0, g = 0, b = 0, n = 0;
        for (var y = 4; y < size - 4; y++) {
          for (var x = 4; x < size - 4; x++) {
            var p = px(x, y);
            var dBg = Math.abs(p[0] - bg[0]) + Math.abs(p[1] - bg[1]) + Math.abs(p[2] - bg[2]);
            if (dBg < 60) continue;
            if (p[0] > 235 && p[1] > 235 && p[2] > 235) continue;
            r += p[0]; g += p[1]; b += p[2]; n++;
          }
        }
        if (n < 12) return;
        dot.style.setProperty('--swatch', 'rgb(' + Math.round(r / n) + ',' + Math.round(g / n) + ',' + Math.round(b / n) + ')');
      } catch (e) { /* photo not readable: keep the grey */ }
    };
    img.src = src;
  }
  function run() {
    if (window.matchMedia('(min-width: 1160px)').matches) return;
    document.querySelectorAll('#product-grid .offe-swatch[data-sample]').forEach(sample);
  }
  function start() {
    run();
    var t;
    var target = document.getElementById('MainContent') || document.body;
    if (window.MutationObserver) {
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 150); })
        .observe(target, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
